export class Oco {
  sixLetterCode: string;
  swapPrice: any;
  quantity: number;
  swapRate: any;
  amount: number;

  constructor(sixLetterCode: string, swapPrice: number, quantity: number, swapRate: number, amount: number = null) {
    this.sixLetterCode = sixLetterCode;
    this.swapPrice = swapPrice;
    this.quantity = quantity;
    this.swapRate = swapRate;
    this.amount = amount;
  }
}
